// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.external_box[data-v-23e16a46]::before {\r\n    background: none;\n}\n.external .content_title h3[data-v-23e16a46]{\r\n    background: none;\r\n    margin-top: -20px;\n}\n.input-form-checkbox input[type=\"checkbox\"] + label[data-v-23e16a46]{\r\n    font-size: 105%;\n}\r\n", ""]);
// Exports
module.exports = exports;
